var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileBlankUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 19 20",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14 21h3.5c1.3807119 0 2.5-1.1192881 2.5-2.5v-10.12833c0-.7956494-.3160708-1.55871101-.87868-2.12132l-2.37167-2.37167c-.562609-.56260918-1.3256706-.87868-2.12132-.87868h-7.12833c-1.38071187 0-2.5 1.11928813-2.5 2.5v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.97643 8h-3.47643c-.8284271 0-1.5-.67157288-1.5-1.5v-3.47638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 20.5v-.406c-.00329564-1.1551164-.93888359-2.0907044-2.094-2.094h-2.812c-1.15511641.0032956-2.09070436.9388836-2.094 2.094v.406c0 .2761424.22385763.5.5.5h6c.27614237 0 .5-.2238576.5-.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 13.5,
    r: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlankUser);
export default __webpack_public_path__ + "static/media/file-blank-user.b8c1d86bae0b3c3e5356952b5201e1f6.svg";
export { ForwardRef as ReactComponent };